import React, {useState, createRef, useEffect, useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import * as S from './RefundRaiseRequestHeader.styles';
import dateformat from 'dateformat';
import search from '../assets/search.png';
import cancelIcon from '../assets/cancel.png';
import useOutsideClick from '@ibibo/use-outside-click';
import RaiseWalletRequest from '../RasieWalletRequest/RasieWalletRequest';
import RaiseWalletRequestGcc from '../RasieWalletRequest/RaiseWalletRequestGcc';
import CalendarBlock from '../../Wallet/RightBlock/WalletStatement/WalletCalendar';
import Modal from '../../../../shared/Modal/Modal';
import {getCookie} from '../../../../utils/getCookie';
import {getRefudRaiseRequest} from '@ibibo/myaccount-reducer';

const RefundRaiseRequestHeader = ({
  setSearchDate,
  setListData,
  modalFlag,
  setModalFlag,
  listData,
  sendTrackingDataToSdk,
}) => {
  if (typeof window === 'undefined') {
    return null;
  }
  const dispatch = useDispatch();
  const ccdeCookie = getCookie('ccde');
  const [openRefundForm, setOpenRefundForm] = useState(false);
  const [walletStatementDates, setDates] = useState({
    startDate: new Date(
      new Date().getMonth() === 0 ? new Date().getFullYear() - 1 : new Date().getFullYear(),
      new Date().getMonth() === 0 ? 11 : new Date().getMonth() - 1,
      new Date().getDate(),
    ),
    endDate: new Date(),
  });
  const startDateRef = createRef();
  const endDateRef = createRef();
  const [calendarMode, setCalendarMode] = useState('');
  const [searchUtr, setSearchUtr] = useState('');
  const [originalDataList, setOriginalDataList] = useState([]);

  const fetchRefundRaiseRequestListingCaller = useCallback(() => {
    return dispatch(
      getRefudRaiseRequest(
        {
          startDate: dateformat(walletStatementDates.startDate, 'yyyy-mm-dd'),
          endDate: dateformat(walletStatementDates.endDate, 'yyyy-mm-dd'),
        },
        successCallback,
        errorCallback,
      ),
    );
  }, [dispatch]);

  useEffect(() => {
    const obj = {
      startDate: dateformat(walletStatementDates.startDate, 'yyyy-mm-dd'),
      endDate: dateformat(walletStatementDates.endDate, 'yyyy-mm-dd'),
    };
    setSearchDate(obj);
    dispatch(
      getRefudRaiseRequest(
        {
          startDate: dateformat(walletStatementDates.startDate, 'yyyy-mm-dd'),
          endDate: dateformat(walletStatementDates.endDate, 'yyyy-mm-dd'),
        },
        successCallback,
        errorCallback,
      ),
    );
  }, [walletStatementDates]);

  const handleMoadalClick = () => {
    setOpenRefundForm(true);
    sendTrackingDataToSdk?.(
      {
        event_detail: {
          event_name: 'click',
          event_type: 'user_action',
          event_value: 'Raise Request clicked',
        },
      },
      'REFUND_RAISE_REQUEST',
    );
  };

  useOutsideClick(startDateRef, () => {
    setCalendarMode('');
  });

  useOutsideClick(endDateRef, () => {
    setCalendarMode('');
  });

  const updateQueryCaller = data => {
    if (
      (data.startDate && data.startDate.toString() !== walletStatementDates.startDate.toString()) ||
      (data.endDate && data.endDate.toString() !== walletStatementDates.endDate.toString())
    ) {
      setDates({
        startDate: data.startDate,
        endDate: data.endDate,
      });
    }
  };

  const updateCalendarState = (event, key) => {
    event.stopPropagation();
    setCalendarMode(key);
  };

  const successCallback = data => {
    setListData(data);
    setOriginalDataList(data);
  };

  const errorCallback = error => {
    sendTrackingDataToSdk?.(
      {
        event_detail: {
          event_name: 'error',
          event_type: 'user_action',
          event_value: `ErrorShown_${error}`,
        },
      },
      'REFUND_RAISE_REQUEST',
    );
  };

  const listFilter = item => {
    return item.utr.toLowerCase().includes(searchUtr.toLowerCase());
  };

  const handleFilter = () => {
    const data = listData;
    const newFilteredData = data.filter(listFilter).map((itm, idx) => {
      return itm;
    });
    setListData(newFilteredData);
    sendTrackingDataToSdk?.(
      {
        event_detail: {
          event_name: 'click',
          event_type: 'user_action',
          event_value: 'Search by UTR clicked',
        },
      },
      'REFUND_RAISE_REQUEST',
    );
  };

  const handleClearAll = () => {
    setListData(originalDataList);
    setSearchUtr('');
  };

  const closeModal = () => {
    setOpenRefundForm(false);
  };

  return (
    <S.Header>
      <h2>Support Requests Raised by You</h2>
      <S.StatementTimeWrap>
        <S.StatementTimeInnerWrap>
          <S.FromTimeWrap onClick={e => updateCalendarState(e, 'start')}>
            <S.FromTimeText>From</S.FromTimeText>
            <S.FromTimeMainText>
              {dateformat(walletStatementDates.startDate, 'dd/mm/yyyy')}
            </S.FromTimeMainText>
          </S.FromTimeWrap>
          {(calendarMode === 'start' && (
            <S.CalendarWrapperFrom>
              <CalendarBlock
                ref={startDateRef}
                isSearchWidget={true}
                isStartMode={calendarMode === 'start'}
                //isEndMode={calendarMode === 'end'}
                onSelection={() => setCalendarMode('end')}
                updateQueryCaller={updateQueryCaller}
                startDate={walletStatementDates.startDate}
                endDate={walletStatementDates.endDate}
              />
            </S.CalendarWrapperFrom>
          )) ||
            null}
          <S.TimeBreakDiv />
          <S.FromTimeWrap onClick={e => updateCalendarState(e, 'end')}>
            <S.FromTimeText>To</S.FromTimeText>
            <S.FromTimeMainText>
              {dateformat(walletStatementDates.endDate, 'dd/mm/yyyy')}
            </S.FromTimeMainText>
          </S.FromTimeWrap>
          {(calendarMode === 'end' && (
            <S.CalendarWrapperTo>
              <CalendarBlock
                ref={endDateRef}
                isSearchWidget={true}
                //isStartMode={calendarMode === 'start'}
                isEndMode={calendarMode === 'end'}
                onSelection={() => {
                  setCalendarMode('');

                  sendTrackingDataToSdk?.(
                    {
                      event_detail: {
                        event_name: 'click',
                        event_type: 'user_action',
                        event_value: 'DateRangeSelected',
                      },
                    },
                    'REFUND_RAISE_REQUEST',
                  );
                }}
                updateQueryCaller={updateQueryCaller}
                startDate={walletStatementDates.startDate}
                endDate={walletStatementDates.endDate}
              />
            </S.CalendarWrapperTo>
          )) ||
            null}
        </S.StatementTimeInnerWrap>
      </S.StatementTimeWrap>
      <S.Search>
        {/*<span className='clearSpan' onClick={handleClearAll}>X</span>*/}
        <input
          type="text"
          placeholder={ccdeCookie === 'AE' ? 'Search for Reference Number' : 'Search for UTR'}
          value={searchUtr}
          onChange={e => setSearchUtr(e.target.value)}
        />
        <span onClick={handleClearAll} className="clearCancel">
          <img src={cancelIcon} />
        </span>
        <button onClick={handleFilter}>
          <span className="clearSpan">
            <img src={search} />
          </span>
        </button>
      </S.Search>
      <S.Cta onClick={handleMoadalClick}>Raise Request</S.Cta>
      {(modalFlag || openRefundForm) && (
        <Modal
          closeModal={() => {
            setOpenRefundForm(false);
            setModalFlag(false);
          }}
        >
          {' '}
          {ccdeCookie == 'AE' ? (
            <RaiseWalletRequestGcc setModalFlag={setModalFlag} closeModal={closeModal} />
          ) : (
            <RaiseWalletRequest
              setModalFlag={setModalFlag}
              closeModal={closeModal}
              sendTrackingDataToSdk={sendTrackingDataToSdk}
            />
          )}{' '}
        </Modal>
      )}
    </S.Header>
  );
};

export default RefundRaiseRequestHeader;
